import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Typography,
  CardContent,
  Stack,
  Box,
  Divider,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import errorHandler from "../../utils/errorHandler";
import CardLayout from "../../layouts/CardLayout";
import { apiCategory } from "../../services/productService";

const ViewSubLastCategory = () => {
  const { id } = useParams();
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiCategory.getByIdSubCategory({
          subCategoryId: id,
        });
        setData(response?.data?.data);
      } catch (error) {
        errorHandler(error);
      }
    };

    fetchData();
  }, [id]);

  // Helper to format ISO date strings to readable format
  const formatDate = (isoDate) =>
    isoDate ? new Date(isoDate).toLocaleString() : "-";

  return (
    <Box>
      <Helmet>
        <title>View Sub Category</title>
      </Helmet>
      <CardLayout title="View Sub Category">
        <CardContent>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12 }} md={12}>
              <Card sx={{ boxShadow: 4, borderRadius: 3, overflow: "hidden" }}>
                <CardContent>
                  <Stack spacing={2}>
                    <Typography variant="h6">Name</Typography>
                    <Typography
                      variant="body1"
                      sx={{ overflowWrap: "break-word" }}
                    >
                      {data?.name || data?.title || "-"}
                    </Typography>
                    <Divider />

                    <Typography variant="h6">Status</Typography>
                    <Typography variant="body1">
                      {data?.status === "active" || data?.status === 1
                        ? "Active"
                        : "Inactive"}
                    </Typography>
                    <Divider />

                    <Typography variant="h6">Created At</Typography>
                    <Typography variant="body1">
                      {formatDate(data?.createdAt)}
                    </Typography>
                    <Divider />

                    <Typography variant="h6">Updated At</Typography>
                    <Typography variant="body1">
                      {formatDate(data?.updatedAt)}
                    </Typography>
                    <Divider />
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </CardLayout>
    </Box>
  );
};

export default ViewSubLastCategory;
